export const dateMask = (value: string) => {
  if (!value) return "";
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{4})\d+?$/, "$1");
};

export const timeMask = (value: string) => {
  if (!value) return "";
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1:$2")
    .replace(/(\d{2}:\d{2})\d+?$/, "$1");
};

export const cnpjMask = (value: string) => {
  if (!value) return "";
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
};

export const currencyMask = (value: string) => {
  if (!value) return "";
  let onlyNumbers = value.replace(/\D/g, "");
  if (onlyNumbers === "") return "";

  // Adiciona zeros à esquerda se necessário para ter pelo menos 3 dígitos
  while (onlyNumbers.length < 3) {
    onlyNumbers = "0" + onlyNumbers;
  }

  let intValue = onlyNumbers.slice(0, -2);
  const decimalValue = onlyNumbers.slice(-2);

  intValue = intValue.replace(/^0+/, "");

  if (intValue === "") {
    intValue = "0";
  }

  const formattedIntValue = new Intl.NumberFormat("pt-BR").format(parseInt(intValue, 10));

  return `R$ ${formattedIntValue},${decimalValue}`;
};

export const unmaskCurrency = (maskedValue: string): number => {
  if (!maskedValue) return 0;
  const numericString = maskedValue.replace(/[^0-9]/g, "");
  if (!numericString) return 0;
  // Converte para um número, tratando os dois últimos dígitos como centavos
  return parseFloat(numericString) / 100;
};

export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength).trim() + "...";
};
